<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :visible="dialogVisible"
      width="1000px"
      top="10px"
      @close="handleClose"
      center
      append-to-body
    >
      <el-form :model="form" ref="form" label-width="100px" label-position="left" style="width: 100%;">
        <!--
        <el-form-item label="出场弹框">
          <el-radio-group v-model="form.BulletFrame">
            <el-radio :label="0">智能弹出</el-radio>
            <el-radio :label="1">手动弹出</el-radio>
          </el-radio-group>
        </el-form-item>-->
        <el-form-item label="收费快捷键" v-if="typeTitle !== '车都'">
          <el-radio-group v-model="ChargeHotKey">
            <el-radio-button label="空格键" :disabled="true"></el-radio-button>
          </el-radio-group>
<!--          <el-input v-model="ChargeHotKey" :disabled="true"></el-input>-->
        </el-form-item>
        <el-form-item label="收费字段显示">
          <el-select v-model="form.ChargeFieldsArr" multiple clearable placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in form.ChargeFieldList"
              :key="item.Value"
              :label="item.Key"
              :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型修改显示">
          <el-radio-group v-model="form.EditCarType">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="扫码枪支付">
          <el-radio-group v-model="form.ShowCodeGun">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="免费订单弹框显示" label-width="160px">
          <span slot="label">免费订单弹框显示
            <el-tooltip class="item" effect="dark" placement="top">
              <span slot="content">
                如果后台停车场设置了免费临停车订单确认离场,该停车场免费订单会一直提示,参数设置不生效
              </span>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-radio-group v-model="form.FreeOrderShow">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收费按钮显示">
          <el-select v-model="form.ChargeButtonArr" multiple clearable placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in form.ChargeButtonList"
              :key="item.Value"
              :label="item.Key"
              :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="锁闸功能">
          <el-radio-group v-model="form.LockGate">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入场信息显示设置" label-width="160px">
          <el-radio-group v-model="form.ShowPassIn">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="营收数据统计字段显示" label-width="170px" v-if="form.ShowStatistics">
          <span slot="label">营收数据统计字段显示
            <el-tooltip placement="top">
              <div slot="content" class="tootipActive">
                <span>实收：线上+线下+优惠券</span>
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-select v-model="form.SentryStatFieldsArr" multiple clearable placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in form.SentryStatFieldsList"
              :key="item.Value"
              :label="item.Key"
              :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营收数据统计字段排序" label-width="160px" v-if="form.ShowStatistics">
          <el-button type="success" @click="showHandleSort = true">排序</el-button>
        </el-form-item>
        <el-form-item label="收费弹框显示设置" label-width="160px">
          <el-radio-group v-model="form.ChargeBullet">
            <el-radio :label="1">一直显示</el-radio>
            <el-radio :label="0">车辆离场自动关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收费弹框车牌设置" label-width="160px">
          <el-col :span="4">
            <el-radio-group v-model="form.BulletPlateSize" size="mini">
              <el-radio-button :label="3">大</el-radio-button>
              <el-radio-button :label="2">中</el-radio-button>
              <el-radio-button :label="1">小</el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-select v-model="form.BulletPlateColor" placeholder="请选择" size="mini">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="我的信息" v-if="form.ShowStatistics">
          <el-select v-model="form.MyFieldArr" multiple clearable placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in form.MyFieldList"
              :key="item.Value"
              :label="item.Key"
              :value="item.Value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监控视频区域显示" label-width="160px">
          <el-radio-group v-model="form.ShowVideo">
            <el-radio :label="1">视频</el-radio>
            <el-radio :label="2">图片</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">确 定</el-button>
        <el-button type="warning" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <dialog-notice-sort v-if="showHandleSort" :showdialog.sync="showHandleSort" :sortSentryStatFields="form.sortSentryStatFields"></dialog-notice-sort>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
import { curlSentryUserConfig } from "@/api/module/tenant";
import { getTenantId } from "@/utils/service";
import {settingPubSub} from '../service/pubsub/index'
import dialogNoticeSort from "@/serviceComponents/dialogNoticeSort";
import { distinguishTitle } from "@/utils/index";

export default {
  components: {
    dialogNoticeSort
  },
  data() {
    return {
      // form: {
      //   BulletFrame: 1,
      //   ChargeHotKey: "空格键",
      // },
      ChargeHotKey: "空格键",
      TenantId: null,
      showHandleSort: false,
      options: [{
        value: 1,
        label: '黑'
      }, {
        value: 2,
        label: '红'
      }, {
        value: 3,
        label: '黄'
      }, {
        value: 4,
        label: '蓝'
      }],
      typeTitle: undefined,
    };
  },
  mixins: [showdialog],
  props: {
    form: {
      type: Object,
      default: function() {
        return {
          BulletFrame: 1,
          ShowCodeGun: 1,
          EditCarType: 1,
          FreeOrderShow: 1,
          ChargeFieldsArr: [],
          ChargeFieldList: [],
          ChargeButtonList: [],
          ChargeButtonArr: [],
          LockGate: 1,
          ShowPassIn: 1,
          SentryStatFieldsArr: [],
          SentryStatFieldsList: [],
          sortSentryStatFields: [],
          ChargeBullet: 1,
          BulletPlateColor: 1,
          BulletPlateSize: 1,
          MyFieldList: [],
          MyFieldArr: [],
          ShowVideo: 1,
          ShowStatistics: 1,
        }
      }
    },
  },
  computed: {
    tenantId: function () {
      return this.$store.state.user.tenantId;
    },
    isManager:function(){
      return this.$store.state.user.isManager;
    },
    showPassInStr: {
      get () {
        return this.$store.state.layout.showPassInStr
      },
      set (value) {
        this.$store.dispatch('SetShowPassInStr', value)
      }
    },
  },
  mounted() {
    this.typeTitle = distinguishTitle();
    this.TenantId = parseInt(getTenantId());
  },
  methods: {
    handleClick() {
      let param = {
        SentryId: Number(sessionStorage.getItem("sentryId")),
        IsUpdate: 1,
        ChargeHotKey: this.ChargeHotKey,
        BulletFrame: this.form.BulletFrame,
        ChargeFields: this.form.ChargeFieldsArr.join(','),
        EditCarType: this.form.EditCarType,
        ShowCodeGun: this.form.ShowCodeGun,
        FreeOrderShow: this.form.FreeOrderShow,
        ButtonFields: this.form.ChargeButtonArr.join(','),
        LockGate: this.form.LockGate,
        ShowPassIn: this.form.ShowPassIn,
        SentryStatFields: this.form.SentryStatFieldsArr.join(','),
        ChargeBullet: this.form.ChargeBullet,
        BulletPlateColor: this.form.BulletPlateColor,
        BulletPlateSize: this.form.BulletPlateSize,
        MyFields: this.form.MyFieldArr.join(','),
        ShowVideo: this.form.ShowVideo,
        ShowStatistics: this.form.ShowStatistics,
      };
      // console.log(param);
      let setConfig = {
        BulletFrame: this.form.BulletFrame,
        EditCarType: this.form.EditCarType,
        ShowCodeGun: this.form.ShowCodeGun,
        FreeOrderShow: this.form.FreeOrderShow,
        ChargeList: [],
        ChargeButton: [],
        LockGate: this.form.LockGate,
        ShowPassIn: this.form.ShowPassIn,
        SentryStatFields: [],
        ChargeBullet: this.form.ChargeBullet,
        BulletPlateColor: this.form.BulletPlateColor,
        BulletPlateSize: this.form.BulletPlateSize,
        MyField: [],
        ShowVideo: this.form.ShowVideo,
        ShowStatistics: this.form.ShowStatistics,
      };
      setConfig.ChargeList = this.form.ChargeFieldsArr.map(v => {
        let arr = this.form.ChargeFieldList.filter(val => {return v === val.Value});
        return arr[0].Key
      });
      setConfig.ChargeButton = this.form.ChargeButtonArr.map(v => {
        let arr = this.form.ChargeButtonList.filter(val => {return v === val.Value});
        return arr[0].Key
      });
      setConfig.SentryStatFields = this.form.SentryStatFieldsArr.map(v => {
        let arr = this.form.SentryStatFieldsList.filter(val => {return v === val.Value});
        return arr[0].Key
      });
      setConfig.MyField = this.form.MyFieldArr.map(v => {
        let arr = this.form.MyFieldList.filter(val => {return v === val.Value});
        return arr[0].Key
      });
      param.TenantId = this.isManager ? this.TenantId : undefined;
      curlSentryUserConfig(param).then((res) => {
        if (res.state === "success") {
          this.$message.success(res.message);
          this.$emit("update:showdialog", false);
          localStorage.setItem('frameStyle', this.form.BulletFrame * 1);
          this.$store.dispatch("SetSettingConfig", setConfig);
          settingPubSub.publish(setConfig);
          let showPassIn = JSON.parse(this.showPassInStr);
          showPassIn[sessionStorage.getItem('sentryId')] = Boolean(setConfig.ShowPassIn);
          this.$store.dispatch("SetShowPassInStr", JSON.stringify(showPassIn));
          this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'clear'});
          this.$store.dispatch("SetSettingNotice", JSON.stringify(setConfig.SentryStatFields));
        } else {
          this.$message.error(res.message);
        }
      })
    },
  },
};
</script>
